import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Search, FileText, Filter } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LOG_TYPE_COLORS = {
  auth: '#3182CE',
  provisioning: '#38A169',
  publishing: '#9F7AEA',
  automation: '#D69E2E',
  admin: '#E53E3E',
  support: '#ED8936',
  billing: '#4FD1C5',
  error: '#FC8181',
  info: '#718096'
};

export default function SaaSLogs() {
  const [logs, setLogs] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({ log_type: '', module: '' });

  useEffect(() => { fetchLogs(); }, [filters]);

  const fetchLogs = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.log_type) params.append('log_type', filters.log_type);
      if (filters.module) params.append('module', filters.module);
      const res = await axios.get(`${API}/saas/logs?${params.toString()}&limit=100`);
      setLogs(res.data.items);
      setTotal(res.data.total);
    } catch { toast.error('Failed to load logs'); }
    finally { setLoading(false); }
  };

  return (
    <div className="saas-page" data-testid="saas-logs">
      <div className="saas-page-header">
        <div>
          <h2>System Logs</h2>
          <p>{total} log entries</p>
        </div>
      </div>

      <div className="saas-filters">
        <select value={filters.log_type} onChange={(e) => setFilters(p => ({ ...p, log_type: e.target.value }))} className="filter-select" data-testid="filter-log-type">
          <option value="">All Types</option>
          <option value="auth">Auth</option>
          <option value="provisioning">Provisioning</option>
          <option value="publishing">Publishing</option>
          <option value="automation">Automation</option>
          <option value="admin">Admin</option>
          <option value="support">Support</option>
          <option value="billing">Billing</option>
          <option value="error">Error</option>
        </select>
      </div>

      <div className="saas-table-container">
        <table className="saas-table" data-testid="logs-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Type</th>
              <th>Tenant</th>
              <th>Module</th>
              <th>Action</th>
              <th>Description</th>
            </tr>
          </thead>
          <tbody>
            {logs.map(log => (
              <tr key={log.id}>
                <td className="timestamp-cell">{new Date(log.created_at).toLocaleString()}</td>
                <td>
                  <span className="log-type-badge" style={{ background: `${LOG_TYPE_COLORS[log.log_type] || '#718096'}20`, color: LOG_TYPE_COLORS[log.log_type] || '#718096' }}>
                    {log.log_type}
                  </span>
                </td>
                <td>{log.tenant_name || 'Platform'}</td>
                <td><span className="module-badge">{log.module || '-'}</span></td>
                <td><strong>{log.action}</strong></td>
                <td className="description-cell">{log.description}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {logs.length === 0 && !loading && <div className="empty-state"><p>No logs found</p></div>}
      </div>
    </div>
  );
}
